// removed by extract-text-webpack-plugin
module.exports = {"baseFrame":"_27jWd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IframeViewer/IframeViewer.scss
// module id = 2499
// module chunks = 0